
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { Action } from "vuex-class";
import { AxiosError, AxiosResponse } from "axios";
import {
  downloadBlob,
  onScroll,
  randomColor,
} from "@/functions/global.function";
import _ from "lodash";
import {
  AdminJobFairAuthorizationEnum,
  AdminJobFairJobApplicantStatusEnum,
  AdminJobFairOrganizerUserAuthorizationEnum,
  AdminJobFairTodoStatusEnum,
  AdminJobFairTransactionCategoryEnum,
  EnumHelper,
} from "@/constants/enum.constant";
import { setSchoolToken } from "@/functions/token.function";
import PieChart from "@/components/charts/PieChart.vue";
import HorizontalBarChart from "@/components/charts/HorizontalBarChart.vue";
import LineChart from "@/components/charts/LineChart.vue";
import ModalJobDetail from "@/views/ModalJobDetail.vue";
import toast from "@/functions/toast.function";
import moment from "moment";
import Loading from "@/components/Loading.vue";
import ModalBroadcastCandidate from "@/views/ModalBroadcastCandidate.vue";
import ModalBroadcastCompany from "@/views/ModalBroadcastCompany.vue";
import { ChartOptions } from "chart.js";

@Component({
  components: {
    ModalBroadcastCompany,
    ModalBroadcastCandidate,
    Loading,
    ModalJobDetail,
    LineChart,
    AppLayout,
    PieChart,
    HorizontalBarChart,
  },
  filters,
})
export default class OrganizerDashboard extends Vue {
  @Action("getAdminJobFairOrganizerSelf", { namespace: "admin" })
  getAdminJobFairOrganizerSelf: any;
  @Action("getAdminJobFairDetail", { namespace: "admin" })
  getAdminJobFairDetail: any;
  @Action("setAdminJobFairTodoStatus", { namespace: "admin" })
  setAdminJobFairTodoStatus: any;
  @Action("AdminJobFairOrganizerDownload", { namespace: "admin" })
  AdminJobFairOrganizerDownload: any;
  @Action("AdminJobFairOrganizerDownloadCompanies", { namespace: "admin" })
  AdminJobFairOrganizerDownloadCompanies: any;
  @Action("AdminJobFairOrganizerDownloadCompany", { namespace: "admin" })
  AdminJobFairOrganizerDownloadCompany: any;
  @Action("getAdminJobFairOrganizerCandidate", { namespace: "admin" })
  getAdminJobFairOrganizerCandidate: any;
  @Action("getAdminJobFairOrganizerCompany", { namespace: "admin" })
  getAdminJobFairOrganizerCompany: any;
  @Action("getAdminJobFairOrganizerCompanyJob", { namespace: "admin" })
  getAdminJobFairOrganizerCompanyJob: any;
  @Action("getAdminJobFairOrganizerCandidateAppliedJobs", {
    namespace: "admin",
  })
  getAdminJobFairOrganizerCandidateAppliedJobs: any;
  @Action("getAdminJobFairOrganizerChartAttendance", { namespace: "admin" })
  getAdminJobFairOrganizerChartAttendance: any;
  @Action("getAdminJobFairOrganizerChartCompany", { namespace: "admin" })
  getAdminJobFairOrganizerChartCompany: any;
  @Action("getAdminJobFairOrganizerChartCategory", { namespace: "admin" })
  getAdminJobFairOrganizerChartCategory: any;
  @Action("getAdminJobFairOrganizerChartDaily", { namespace: "admin" })
  getAdminJobFairOrganizerChartDaily: any;
  @Action("getAdminJobFairOrganizerChartIndustry", { namespace: "admin" })
  getAdminJobFairOrganizerChartIndustry: any;
  @Action("getAdminJobFairOrganizerChartIndustryJob", { namespace: "admin" })
  getAdminJobFairOrganizerChartIndustryJob: any;
  @Action("getAdminJobFairOrganizerChartJob", { namespace: "admin" })
  getAdminJobFairOrganizerChartJob: any;
  @Action("getAdminJobFairOrganizerChartApplication", { namespace: "admin" })
  getAdminJobFairOrganizerChartApplication: any;
  @Action("getAdminJobFairOrganizerChartApplicationStatus", {
    namespace: "admin",
  })
  getAdminJobFairOrganizerChartApplicationStatus: any;

  
  public get jobfairURL() {
    return [location.origin, this.jobFair.slug].join('/')
  }

  public get cardSate(): Array<{ text: string, state: boolean, tip?:string }> {
    const maxCompanies = this.jobFair?.max_companies || 0
    const availableCompanyQuota = maxCompanies - this.jobFair?.companies_count
    return [
      {
        text: "Salin/Bagikan Tautan Job Fair",
        tip: " Salin/Bagikan tautan acara ke calon peserta job fair dengan menekan tombol Salin/Bagikan yang tersedia di samping bagian link.",
        // state: this.localCardState.copyShare
        state: this.getTodoStatus(AdminJobFairTodoStatusEnum.COPY_SHARE).status
      },
      {
        text: "Download QR Registrasi dan Check In Peserta",
        tip: "Download Kode QR Pendaftaran dan Check In di hari acara job fair (PIN bisa saja berbeda di setiap harinya jika acara diadakan lebih dari satu hari)",
        // state: this.localCardState.downloadQrRegistration
        state: this.getTodoStatus(AdminJobFairTodoStatusEnum.DOWNLOAD_QR_REGISTRATION).status
      },
      {
        text: "Download QR Booth Perusahaan",
        tip: "Download Kode QR untuk seluruh booth perusahaan",
        // state: this.localCardState.downloadQrCompany
        state: this.getTodoStatus(AdminJobFairTodoStatusEnum.DOWNLOAD_QR_COMPANY).status
      },
      {
        text: `Kuota peserta perusahaan : ${this.jobFair?.companies_count} dari ${maxCompanies} (tersisa ${availableCompanyQuota})`,
        // state: availableCompanyQuota === 0
        state: this.getTodoStatus(AdminJobFairTodoStatusEnum.QUOTA_COMPANY).status
      }
    ]
  }
  
  localCardState = { copyShare: false, downloadQrRegistration: false, downloadQrCompany: false }
  candidates: Array<any> = [];
  companies: Array<any> = [];
  totalCompanies = 0;
  applies: Array<any> = [];
  jobs: Array<any> = [];
  chartJobs: Array<any> = [];
  chartApplications: Array<any> = [];
  profile: any = null;
  jobFair: any = null;
  candidate: any = null;
  company: any = null;
  job: any = null;
  generalStatus: any = null;
  individualStatus: any = null;
  generalCandidateSearch = "";
  individualCandidateSearch = "";
  generalCompanySearch = "";
  searchJob = "";
  tab = 1;
  pageCandidate = 1;
  pageCompany = 1;
  pageJob = 1;
  pageChartJob = 1;
  pageChartApplication = 1;
  pageApplies = 1;
  isLastPageCandidate = false;
  isLastPageCompany = false;
  isLastPageJob = false;
  isLastPageChartJob = false;
  isLastPageChartApplication = false;
  isLastPageApplies = false;
  isLoadingSelf = false;
  isLoadingJobFair = false;
  isLoadingCandidate = false;
  isLoadingCompany = false;
  isLoadingJob = false;
  isLoadingChartJob = false;
  isLoadingChartApplication = false;
  isLoadingApplies = false;
  isLoadingQrGeneral = false;
  isLoadingQrCompany = false;
  showChart = false;
  defaultBroadcastCandidate = {
    subject: "",
    body: "",
    attachments: [],
    attendance: false,
    registered: false,
  };
  dataBroadcastCandidate = { ...this.defaultBroadcastCandidate };
  defaultBroadcastCompany = {
    subject: "",
    body: "",
    attachments: [],
  };
  dataBroadcastCompany = { ...this.defaultBroadcastCompany };
  statuses = EnumHelper(AdminJobFairJobApplicantStatusEnum).map(
    (value) => ({
      ...value,
      translation: this.$t(
        `status_${value.name.toLowerCase().replaceAll(" ", "_")}`
      ),
    })
  );
  categories = EnumHelper(AdminJobFairTransactionCategoryEnum).map(
    (value) => ({
      ...value,
      translation: (
        this.$t(`category_${value.name.toLowerCase()}`) as any
      ).replaceAll(" {organizer}", ""),
    })
  );
  pieChartOptions = {
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          return `: ${data.datasets[0].data[tooltipItem.index]}`;
        },
      },
    },
  };
  horizontalBarChartOptions = {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  lineChartOptions:ChartOptions = {
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          return `: ${data.datasets?.[0]?.data?.[tooltipItem?.index||0]}`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 1
          },
        },
      ],
    },
  };
  candidateAttendanceChart = {
    labels: ["Hadir", "Tidak hadir"],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ["#17B284", "#EDA519"],
      },
    ],
    customData: {
      total: 0,
    },
  };
  companyChart = {
    company: 0,
    application: 0,
    job: 0,
  };
  candidateCategoryChart = {
    labels: ["Alumni", "Siswa aktif", "Peserta umum"],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: Array.from({ length: 3 }, () => "#17B284"),
      },
      {
        data: [0, 0, 0],
        backgroundColor: Array.from({ length: 3 }, () => "#EDA519"),
      },
    ],
    customLabels: [
      "Alumni hadir",
      "Alumni tidak hadir",
      "Siswa aktif hadir",
      "Siswa aktif tidak hadir",
      "Peserta umum hadir",
      "Peserta umum tidak hadir",
    ],
    customData: {
      totalAlumni: 0,
      totalActive: 0,
      totalGeneral: 0,
    },
  };
  candidateDailyChart = {
    labels: [],
    datasets: [
      {
        data: [],
        borderColor: ["#FFCB47"],
        fill: false,
      },
    ],
  };
  industryChart = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
    customData: {
      total: 0,
    },
  };
  industryJobChart = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
    customData: {
      total: 0,
    },
  };
  candidateApplicationChart = {
    labels: [
      "Baru",
      "Sudah Dibuka",
      "Diundang Wawancara",
      "Ditolak",
      "Diterima",
    ],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: Array.from({ length: 5 }, () => randomColor()),
      },
    ],
  };

  get canLiveActivity() {
    return moment().isBetween(
      this.jobFair.start_date,
      moment(this.jobFair.end_date).add(1, "day")
    );
  }
  get canStatistics() {
    return this.jobFair?.authorizations?.find(
      (value) => value.code === AdminJobFairAuthorizationEnum.STATISTICS
    )?.is_allowed;
  }
  get canApplicantList() {
    return this.profile?.authorizations?.find(
      (value) =>
        value.code === AdminJobFairOrganizerUserAuthorizationEnum.APPLICANT_LIST
    )?.is_allowed;
  }
  get canCompanyList() {
    return this.profile?.authorizations?.find(
      (value) =>
        value.code === AdminJobFairOrganizerUserAuthorizationEnum.COMPANY_LIST
    )?.is_allowed;
  }
  get canMetrics() {
    return this.profile?.authorizations?.find(
      (value) =>
        value.code === AdminJobFairOrganizerUserAuthorizationEnum.METRICS
    )?.is_allowed;
  }
  get canQr() {
    return this.profile?.authorizations?.find(
      (value) => value.code === AdminJobFairOrganizerUserAuthorizationEnum.QR
    )?.is_allowed;
  }
  get isOneDay() {
    return moment(this.jobFair?.start_date).isSame(
      this.jobFair?.end_date,
      "day"
    );
  }

  public get localCardStateKey() {
    const schoolToken = localStorage.getItem("school_token")
    if (schoolToken && this.jobFair) return `${schoolToken}:JF-${this.jobFair?.id}:state`
    else return false
  }

  @Watch("localCardState", { deep: true })
  onChangeLocalCardState(v) {
    if (!this.localCardStateKey) return
    localStorage.setItem(this.localCardStateKey, JSON.stringify(v))
  }

  @Watch("jobFair")
  onChangeJobFair({ id }) {
    if (!this.localCardStateKey) return
    const state = localStorage.getItem(this.localCardStateKey)
    if (state) {
      this.localCardState = JSON.parse(state)
    }
    localStorage.setItem(this.localCardStateKey, JSON.stringify(this.localCardState))
  }

  created() {
    if (this.$route.query && this.$route.query.token) {
      setSchoolToken(this.$route.query.token.toString());
      this.$router.push({
        name: "school-dashboard",
        params: this.$route.params,
      });
    }

    this.getProfile();

    this.websocketWatcher();
  }

  share(data?: ShareData) {
    if (navigator.share === undefined) {
      toast.error("Coba untuk memberikan izin akses untuk situs ini", "Fitur bagikan data tidak tersedia!")
      return;
    }

    navigator.share(data).then(() => {
      // unused code, please remove this on next release!
      // this.localCardState.copyShare = true

      this.setAdminJobFairTodoStatus({
        params: {
          id: this.jobFair?.id,
          type: AdminJobFairTodoStatusEnum.COPY_SHARE,
          status: true,
        },
        success: (response: AxiosResponse) => {
          this.getData();
        },
      });
    }).catch((e) => {
      // Check if canceled
      if (e.message.toLowerCase().includes("canceled")) return;

      toast.error("Coba untuk memberikan izin akses untuk situs ini", "Fitur bagikan data tidak tersedia!")
    })
  }
  async copy(data: string) {
    navigator.clipboard.writeText(data).then(() => {
      // unused code, please remove this on next release!
      // this.localCardState.copyShare = true

      this.setAdminJobFairTodoStatus({
        params: {
          id: this.jobFair?.id,
          type: AdminJobFairTodoStatusEnum.COPY_SHARE,
          status: true,
        },
        success: (response: AxiosResponse) => {
          this.getData();
        },
      });
      toast.success("Disalin ke clipboard", "berhasil")
    }).catch(() => {
      toast.error("Coba untuk memberikan izin akses untuk situs ini", "Fitur salin data tidak tersedia!")
    })
  }
  websocketWatcher() {
    (window as any).socket.onmessage = (event) => {
      const data = JSON.parse(event?.data);
      switch (data.chart) {
        case "attendance":
          this.setChartAttendance(data.data);
          break;
        case "company":
          this.setChartCompany(data.data);
          break;
        case "category":
          this.setChartCategory(data.data);
          break;
        case "daily":
          this.setChartDaily(data.data);
          break;
        case "industry":
          this.setChartIndustry(data.data);
          break;
        case "industry-job":
          this.setChartIndustryJob(data.data);
          break;
        case "job":
          this.getChartJob(true);
          break;
        case "application":
          this.getChartApplication(true);
          break;
        case "application-status":
          this.setChartApplicationStatus(data.data);
          break;
      }
    };
  }

  isPending(status) {
    return status === AdminJobFairJobApplicantStatusEnum.PENDING;
  }
  isInReview(status) {
    return status === AdminJobFairJobApplicantStatusEnum.IN_REVIEW;
  }
  isInvited(status) {
    return status === AdminJobFairJobApplicantStatusEnum.INVITED;
  }
  isRejected(status) {
    return status === AdminJobFairJobApplicantStatusEnum.REJECTED;
  }
  isApproved(status) {
    return status === AdminJobFairJobApplicantStatusEnum.APPROVED;
  }

  debounce(callback: any) {
    _.debounce(callback, 500)();
  }

  toggleChart() {
    if (!this.canStatistics) {
      toast.warning("Anda tidak memiliki akses ke laporan lengkap.");
      return false;
    }
    this.showChart = !this.showChart;
    if (this.showChart) {
      setTimeout(() => {
        onScroll(".school-company-jobs-chart", this.getChartJob);
      }, 500);
      setTimeout(() => {
        onScroll(
          ".school-company-applications-chart",
          this.getChartApplication
        );
      }, 500);
    }
  }

  getProfile() {
    this.isLoadingSelf = true;
    this.getAdminJobFairOrganizerSelf({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.profile = response.data.data;
        this.getData();
        if (this.canApplicantList) {
          this.getCandidateData(true);
        }
        if (this.canCompanyList) {
          this.getCompanyData(true);
        }
        if (this.canMetrics) {
          this.getMetrics();
        }
      },
      finally: () => {
        this.isLoadingSelf = false;
      },
    });
  }

  getMetrics() {
    this.getAdminJobFairOrganizerChartAttendance({
      success: (response: AxiosResponse) => {
        this.setChartAttendance(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartCompany({
      success: (response: AxiosResponse) => {
        this.setChartCompany(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartCategory({
      success: (response: AxiosResponse) => {
        this.setChartCategory(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartDaily({
      success: (response: AxiosResponse) => {
        this.setChartDaily(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartIndustry({
      success: (response: AxiosResponse) => {
        this.setChartIndustry(response.data.data);
      },
    });
    this.getAdminJobFairOrganizerChartIndustryJob({
      success: (response: AxiosResponse) => {
        this.setChartIndustryJob(response.data.data);
      },
    });
    this.getChartJob(true);
    this.getChartApplication(true);
    this.getAdminJobFairOrganizerChartApplicationStatus({
      success: (response: AxiosResponse) => {
        this.setChartApplicationStatus(response.data.data);
      },
    });
  }

  setChartAttendance(data) {
    this.candidateAttendanceChart.datasets[0].data[0] = data.present;
    this.candidateAttendanceChart.datasets[0].data[1] = data.absent;
    this.candidateAttendanceChart.customData.total = data.total;
  }

  setChartCompany(data) {
    this.companyChart.company = data.company;
    this.companyChart.application = data.application;
    this.companyChart.job = data.job;
  }

  setChartCategory(data) {
    this.candidateCategoryChart.customData.totalAlumni = data.alumni;
    this.candidateCategoryChart.customData.totalActive = data.active;
    this.candidateCategoryChart.customData.totalGeneral = data.general;
    this.candidateCategoryChart.datasets[0].data[0] = data.alumni_present;
    this.candidateCategoryChart.datasets[0].data[1] = data.active_present;
    this.candidateCategoryChart.datasets[0].data[2] = data.general_present;
    this.candidateCategoryChart.datasets[1].data[0] = data.alumni_absent;
    this.candidateCategoryChart.datasets[1].data[1] = data.active_absent;
    this.candidateCategoryChart.datasets[1].data[2] = data.general_absent;
  }

  setChartDaily(data) {
    this.candidateDailyChart.labels = data.map((value) =>
      filters.date(value.date, "DD MMM")
    );
    this.candidateDailyChart.datasets[0].data = data.map(
      (value) => value.total
    );
  }

  setChartIndustry(data) {
    this.industryChart.labels = data.map((value) => value.name);
    this.industryChart.datasets[0].data = data.map(
      (value) => value.admin_job_fair_companies_count
    );
    this.industryChart.datasets[0].backgroundColor = data.map(() =>
      randomColor()
    );
    this.industryChart.customData.total = data.filter(
      (value) => value.admin_job_fair_companies_count > 0
    ).length;
  }

  setChartIndustryJob(data) {
    this.industryJobChart.labels = data.map((value) => value.name);
    this.industryJobChart.datasets[0].data = data.map((value) =>
      value.admin_job_fair_companies
        .map((company) => company.jobs_count)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    );
    this.industryJobChart.datasets[0].backgroundColor = data.map(() =>
      randomColor()
    );
    this.industryJobChart.customData.total = data.filter(
      (value) => value.admin_job_fair_companies_count > 0
    ).length;
  }

  setChartApplicationStatus(data) {
    this.candidateApplicationChart.datasets[0].data[0] = data.pending;
    this.candidateApplicationChart.datasets[0].data[1] = data.in_review;
    this.candidateApplicationChart.datasets[0].data[2] = data.invited;
    this.candidateApplicationChart.datasets[0].data[3] = data.rejected;
    this.candidateApplicationChart.datasets[0].data[4] = data.approved;
  }

  getData() {
    this.isLoadingJobFair = true;
    this.getAdminJobFairDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.jobFair = response.data.data;
      },
      fail: (error: AxiosError) => {
        if (error.response?.data.status !== 401)
          this.$router.push({
            name: "not-found",
          });
      },
      finally: () => {
        this.isLoadingJobFair = false;
      },
    });
  }

  resetBroadcastCandidate() {
    this.dataBroadcastCandidate = { ...this.defaultBroadcastCandidate };
  }
  resetBroadcastCompany() {
    this.dataBroadcastCompany = { ...this.defaultBroadcastCompany };
  }

  getCandidateData(isReload: boolean = false) {
    if (isReload) {
      this.candidates = [];
      this.pageCandidate = 1;
      this.isLastPageCandidate = false;
    }
    if (!this.isLoadingCandidate && !this.isLastPageCandidate) {
      this.isLoadingCandidate = true;
      this.getAdminJobFairOrganizerCandidate({
        params: {
          slug: this.$route.params.slug,
          page: this.pageCandidate,
          name: this.generalCandidateSearch,
          last_used_at: this.generalStatus?.id,
        },
        success: (response: AxiosResponse) => {
          const isLastPage =
            response.data.data.last_page === this.pageCandidate;
          this.candidates = [...this.candidates, ...response.data.data.data];
          this.pageCandidate = isLastPage
            ? this.pageCandidate
            : this.pageCandidate + 1;
          this.isLastPageCandidate = isLastPage;
          setTimeout(() => {
            onScroll(".school-candidates", this.getCandidateData);
          }, 500);
        },
        finally: () => {
          this.isLoadingCandidate = false;
        },
      });
    }
  }

  getCompanyData(isReload: boolean = false) {
    if (isReload) {
      this.companies = [];
      this.pageCompany = 1;
      this.isLastPageCompany = false;
    }
    if (!this.isLoadingCompany && !this.isLastPageCompany) {
      this.isLoadingCompany = true;
      this.getAdminJobFairOrganizerCompany({
        params: {
          slug: this.$route.params.slug,
          page: this.pageCompany,
          name: this.generalCompanySearch,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageCompany;
          this.companies = [...this.companies, ...response.data.data.data];
          this.totalCompanies = response.data.data.total;
          this.pageCompany = isLastPage
            ? this.pageCompany
            : this.pageCompany + 1;
          this.isLastPageCompany = isLastPage;
          setTimeout(() => {
            onScroll(".school-companies", this.getCompanyData);
          }, 500);
        },
        finally: () => {
          this.isLoadingCompany = false;
        },
      });
    }
  }

  getApplyData(isReload: boolean = false) {
    if (isReload) {
      this.applies = [];
      this.pageApplies = 1;
      this.isLastPageApplies = false;
    }
    if (!this.isLoadingApplies && !this.isLastPageApplies) {
      this.isLoadingApplies = true;
      this.getAdminJobFairOrganizerCandidateAppliedJobs({
        params: {
          id: this.candidate?.id,
          page: this.pageApplies,
          name: this.individualCandidateSearch,
          status: this.individualStatus?.id,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageApplies;
          this.applies = [...this.applies, ...response.data.data.data];
          this.pageApplies = isLastPage
            ? this.pageApplies
            : this.pageApplies + 1;
          this.isLastPageApplies = isLastPage;
          setTimeout(() => {
            onScroll(".school-candidate-applicants", this.getApplyData);
          }, 500);
        },
        finally: () => {
          this.isLoadingApplies = false;
        },
      });
    }
  }

  getJobData(isReload: boolean = false) {
    if (isReload) {
      this.jobs = [];
      this.pageJob = 1;
      this.isLastPageJob = false;
    }
    if (!this.isLoadingJob && !this.isLastPageJob) {
      this.isLoadingJob = true;
      this.getAdminJobFairOrganizerCompanyJob({
        params: {
          id: this.company?.id,
          page: this.pageJob,
          name: this.searchJob,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageJob;
          this.jobs = [...this.jobs, ...response.data.data.data];
          this.pageJob = isLastPage ? this.pageJob : this.pageJob + 1;
          this.isLastPageJob = isLastPage;
        },
        finally: () => {
          this.isLoadingJob = false;
        },
      });
    }
  }

  getChartJob(isReload: boolean = false) {
    if (isReload) {
      this.chartJobs = [];
      this.pageChartJob = 1;
      this.isLastPageChartJob = false;
    }
    if (!this.isLoadingChartJob && !this.isLastPageChartJob) {
      this.isLoadingChartJob = true;
      this.getAdminJobFairOrganizerChartJob({
        params: {
          page: this.pageChartJob,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.pageChartJob;
          this.chartJobs = [...this.chartJobs, ...response.data.data.data];
          this.pageChartJob = isLastPage
            ? this.pageChartJob
            : this.pageChartJob + 1;
          this.isLastPageChartJob = isLastPage;
        },
        finally: () => {
          this.isLoadingChartJob = false;
        },
      });
    }
  }

  getChartApplication(isReload: boolean = false) {
    if (isReload) {
      this.chartApplications = [];
      this.pageChartApplication = 1;
      this.isLastPageChartApplication = false;
    }
    if (!this.isLoadingChartApplication && !this.isLastPageChartApplication) {
      this.isLoadingChartApplication = true;
      this.getAdminJobFairOrganizerChartApplication({
        params: {
          page: this.pageChartApplication,
        },
        success: (response: AxiosResponse) => {
          const isLastPage =
            response.data.data.last_page === this.pageChartApplication;
          this.chartApplications = [
            ...this.chartApplications,
            ...response.data.data.data,
          ];
          this.pageChartApplication = isLastPage
            ? this.pageChartApplication
            : this.pageChartApplication + 1;
          this.isLastPageChartApplication = isLastPage;
        },
        finally: () => {
          this.isLoadingChartApplication = false;
        },
      });
    }
  }

  switchTab(tab: number) {
    this.tab = tab;
    switch (this.tab) {
      case 1:
        this.generalCandidateSearch = "";
        this.candidate = null;
        this.getCandidateData(true);
        break;
      case 2:
        this.generalCompanySearch = "";
        this.company = null;
        this.getCompanyData(true);
        break;
    }
  }

  setCompany(company) {
    this.company = company;
    setTimeout(() => {
      onScroll(".school-company-jobs", this.getJobData);
    }, 500);
    this.getJobData(true);
  }

  downloadQr() {
    this.isLoadingQrGeneral = true;
    this.AdminJobFairOrganizerDownload({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.localCardState.downloadQrRegistration = true
        downloadBlob(
          response.data,
          `Check In_${this.jobFair.name}_${this.jobFair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingQrGeneral = false;
      },
    });
  }

  downloadQrCompanies() {
    this.isLoadingQrGeneral = true;
    this.AdminJobFairOrganizerDownloadCompanies({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.localCardState.downloadQrCompany = true
        downloadBlob(
          response.data,
          `perusahaan_${this.jobFair.name}_${this.jobFair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingQrGeneral = false;
      },
    });
  }

  downloadQrCompany() {
    this.isLoadingQrCompany = true;
    this.AdminJobFairOrganizerDownloadCompany({
      params: {
        id: this.company?.id,
      },
      success: (response: AxiosResponse) => {
        this.localCardState.downloadQrCompany = true
        downloadBlob(
          response.data,
          `QR Booth_${this.company.name}_${this.jobFair.name}_${this.jobFair.organizer_name}.pdf`
        );
      },
      finally: () => {
        this.isLoadingQrCompany = false;
      },
    });
  }

  getTodoStatus(type: number) {
    const _defaultData = {
      type: 1,
      status: false,
    };

    const arrayTodos: Array<any> = this.jobFair?.todo_statuses || [];

    const findTodo = arrayTodos.find((todo) => todo.type === type);
    return findTodo || _defaultData;
  }
}
